import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import type { IRenewalTemplateTabProps } from '@/@types/insurance';

const SMS_HARD_LIMIT = 500;

export function RenewalSmsTemplateTab({
  template,
  onTemplateChange,
  availableVariables,
}: IRenewalTemplateTabProps) {
  const charCount = template.length;
  const isOverSmsLimit = charCount > 160;

  const insertVariable = (variable: string) => {
    onTemplateChange(template + `{{${variable}}}`);
  };

  return (
    <div className="space-y-4 py-4">
      <div className="space-y-1">
        <Label htmlFor="sms-template">Customer SMS template</Label>
        <p className="text-xs text-muted-foreground">
          Sent as an SMS fallback. Keep it under 160 characters for a single-segment message.
        </p>
      </div>

      <div className="flex flex-wrap gap-1.5">
        {availableVariables.map(variable => (
          <Button
            key={variable}
            type="button"
            variant="outline"
            size="sm"
            onClick={() => insertVariable(variable)}
            className="h-7 px-2 text-xs font-mono"
          >
            {`{{${variable}}}`}
          </Button>
        ))}
      </div>

      <Textarea
        id="sms-template"
        value={template}
        onChange={e => onTemplateChange(e.target.value)}
        rows={5}
        placeholder="Enter SMS template..."
        className="font-mono text-sm resize-none"
        maxLength={SMS_HARD_LIMIT}
      />

      <div className="flex items-center justify-between">
        {isOverSmsLimit && (
          <p className="text-xs text-destructive">
            Template exceeds 160 characters — may send as multiple SMS segments.
          </p>
        )}
        {!isOverSmsLimit && <span />}
        <p className={cn('text-xs', isOverSmsLimit ? 'text-destructive' : 'text-muted-foreground')}>
          {charCount} / 160 characters
        </p>
      </div>
    </div>
  );
}
